import { InfinityTrackingCssClass } from '@helpers/global';
import { imageUrl } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { useBaseProps, withBaseProps } from '@hoc/withBaseProps';
import SvgX from '@img/icons/x.svg';
import CallButton from '@stories/Components/Buttons/CallButton/CallButton';
import PopupWrapper from '@stories/Components/Misc/PopupWrapper/PopupWrapper';
import * as React from 'react';
import S from './ExitIntentPopup.styles';
const ExitIntentPopup = (props) => {
    const [popupIsActive, setPopupIsActive] = React.useState(false);
    const baseProps = useBaseProps();
    const mouseEvent = (e) => {
        // Check if input field is active (Autofill pop-up triggers mouseout)
        if (document.activeElement && document.activeElement.tagName == 'INPUT') {
            return;
        }
        // Check if mouse moves out of window
        if (!e.relatedTarget) {
            // Get popup IDs from local storage
            const storedIds = JSON.parse(localStorage.getItem('popup-ids') || '[]');
            document.removeEventListener('mouseout', mouseEvent);
            // Show popup if local storage doesn't include popup ID
            if (props.showPopup && storedIds.filter((id) => id === baseProps.id).length === 0) {
                setPopupIsActive(true);
            }
        }
    };
    const handleClose = () => {
        // Get popup IDs from local storage
        const storedIds = JSON.parse(localStorage.getItem('popup-ids') || '[]');
        // Add popup ID to local storage
        storedIds.push(baseProps.id);
        localStorage.setItem('popup-ids', JSON.stringify(storedIds));
        // Close/dismiss popup
        setPopupIsActive(false);
    };
    React.useEffect(() => {
        if (!baseProps.id || !props.showPopup) {
            return;
        }
        // Set timer to allow popup to show
        setTimeout(() => {
            document.addEventListener('mouseout', mouseEvent);
        }, 5000);
    }, []);
    return (React.createElement(PopupWrapper, { id: baseProps.id, showPopup: popupIsActive },
        React.createElement(S.Container, null,
            React.createElement(S.Close, { onClick: handleClose, "aria-label": "Close popup" },
                React.createElement(SvgX, null)),
            React.createElement(S.Inner, null,
                props.image && (React.createElement(S.ImageWrapper, null,
                    React.createElement("picture", null,
                        React.createElement("source", { srcSet: imageUrl(props.image, { width: 360, heightratio: 480 / 360 }), media: `${from(Device.TabletLarge)}` }),
                        React.createElement("source", { srcSet: imageUrl(props.image, { width: 1024, heightratio: 184 / 376 }), media: `${from(Device.MobileLarge)}` }),
                        React.createElement(S.Image, { alt: props.image.altText, loading: "eager", role: props.image.altText ? undefined : 'presentation', src: imageUrl(props.image, { width: 376, heightratio: 184 / 376 }), width: "376", height: "184" })),
                    props.cta && (React.createElement(S.CtaOverlay, { href: props.cta.url, className: InfinityTrackingCssClass },
                        React.createElement(S.CtaOverlayText, null, props.cta.text))))),
                React.createElement(S.ContentWrapper, null,
                    props.logo && (React.createElement(S.Logo, { alt: props.logo.altText, loading: "eager", src: imageUrl(props.logo, { width: 145, heightratio: 72 / 145 }), width: "145", height: "72" })),
                    React.createElement(S.Title, null, props.title),
                    props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
                    props.contactCta && (React.createElement(S.ContactWrapper, null,
                        React.createElement(CallButton, { ...props.contactCta }))))))));
};
export default withBaseProps(ExitIntentPopup);
